import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sblock-portada',
  templateUrl: './portada.component.html',
  styleUrls: ['./portada.component.scss'],
})
export class SblockPortadaComponent {
  /** Optional section background; falls back to the default when empty */
  @Input() backgroundColor: string | null = null;
  defaultBackgroundColor = '#f5f4f1';
  secondaryColor = '#932f29';
  linkColor = '#1f2a6e';

  /** Shows skeleton placeholders while the parent is fetching data */
  @Input() loading = false;

  /** Content comes from the parent; no placeholder/demo fallbacks */
  @Input() title = '';
  @Input() subtitle = '';
  @Input() description = '';
  @Input() mainImage = '';

  expandedLinkIndex: number | null = null;

  /** Accordion links (label + HTML description). Provided by the parent. */
  @Input() links: { label: string; description: string }[] = [];

  @Input() primaryButtonLabel = 'Únete ahora';
  @Input() primaryButtonLink = '#';

  get primaryButton(): { label: string; url: string } {
    return { label: this.primaryButtonLabel, url: this.primaryButtonLink };
  }

  secondaryLink = { label: 'Propuesta educativa', url: '#' };

  /** Emitted when the secondary link is clicked (parent decides where to go) */
  @Output() secondaryAction = new EventEmitter<void>();

  onSecondaryClick(event: Event): void {
    event.preventDefault();
    this.secondaryAction.emit();
  }

  toggleLink(index: number): void {
    this.expandedLinkIndex = this.expandedLinkIndex === index ? null : index;
  }

  trackByLink(index: number, link: { label: string; description: string }): string {
    return `${index}|${link.label}`;
  }
}
